function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "casque-color",
  d: "m95.063,-0.143l309.6,0c52.577,0 95.2,42.622 95.2,95.2l0,309.6c0,52.577 -42.623,95.2 -95.2,95.2l-309.6,0c-52.578,0 -95.2,-42.623 -95.2,-95.2l0,-309.6c0,-52.578 42.623,-95.2 95.2,-95.2z",
  fill: "#1890ff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m163.069,205.594c-22.183,1.172 -39.101,19.77 -37.424,42.131c0.543,7.248 11.891,7.301 11.344,0c-1.196,-15.959 9.719,-29.924 26.08,-30.787c7.276,-0.384 7.314,-11.73 0,-11.344l0,0z",
  fill: "#FFFFFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m343.81,205.594c-22.183,1.172 -39.1,19.77 -37.424,42.131c0.543,7.248 11.891,7.301 11.344,0c-1.196,-15.959 9.719,-29.924 26.08,-30.787c7.275,-0.384 7.313,-11.73 0,-11.344l0,0z",
  fill: "#FFFFFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m419.14851,154.17101l-338.69,0.697c-9.744,0.021 -17.627,7.787 -17.607,17.347l0.321,156.339c0.02,9.56 7.935,17.295 17.679,17.275l120.582,-0.25c0.524,-32.489 22.04,-76.076 48.606,-76.131s48.261,43.443 48.919,75.931l120.583,-0.248c9.744,-0.02 17.627,-7.787 17.607,-17.347l-0.322,-156.34c-0.019,-9.558 -7.934,-17.292 -17.678,-17.273zm-259.391,129.298c-23.806,0 -43.105,-19.299 -43.105,-43.105s19.299,-43.105 43.105,-43.105s43.105,19.299 43.105,43.105s-19.299,43.105 -43.105,43.105zm180.44,0c-23.806,0 -43.105,-19.299 -43.105,-43.105s19.299,-43.105 43.105,-43.105s43.105,19.299 43.105,43.105s-19.299,43.105 -43.105,43.105z",
  fill: "#FFFFFF"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Casque",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    xmlSpace: "preserve",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.80883bea.svg";
export { ForwardRef as ReactComponent };